import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AdminSubHeader from '../../layouts/partials/AdminSubheader';
import { connect } from 'react-redux';
import { USERS_ACTIONS } from '../../../redux/users/actions';
import EmployeeForm from '../../forms/EmployeeForm';
import queryString from 'query-string';
import { getCompany } from '../../../services/api/companies';
import { userCreating, userErrors } from '../../../redux/users/selectors';
import { selectUser } from '../../../redux/auth/selectors';

const EmployeesCreate = ({
  isCreating,
  authUser,
  ajaxErrors,
  createUser,
  resetErrors
}) => {
  const defaultCompanyId = queryString.parse(window.location.search).company;
  const [defaultCompany, setDefaultCompany] = useState();

  useEffect(() => {
    if (defaultCompanyId) {
      getCompany(defaultCompanyId).then(company => setDefaultCompany(company));
    }

    return () => {
      resetErrors();
    };
  }, []);

  const handleSubmit = values => {
    const data = {
      firstName: values.firstName,
      companies: { companies: values.companies }
    };

    if (values.email && values.email !== "") {
      data.email = values.email;
    }

    if (values.gender && values.gender !== "") {
      data.gender = values.gender;
    }

    if (values.lastName && values.lastName !== "") {
      data.lastName = values.lastName;
    }

    if (values.size && values.size !== "") {
      data.size = values.size;
    }

    if (values.size && values.size !== '') {
      data.size = values.size;
    }

    if (values.telephone && values.telephone !== '') {
      data.telephone = values.telephone;
    }

    if (values.nationality && values.nationality !== "") {
      data.nationality = values.nationality;
    }

    if (values.vaccinated && values.vaccinated !== "" && values.vaccinated !== "nochange") {
      data.vaccinated = values.vaccinated === "yes";
    }

    if (values.nationalRegistryNumber && values.nationalRegistryNumber !== "" && values.nationalRegistryNumber.indexOf("XXXXXXXX") === -1) {
      data.nationalRegistryNumber = values.nationalRegistryNumber;
    }

    if (values.dateofbirth && values.dateofbirth !== '') {
      data.birthDate = values.dateofbirth.format('YYYY-MM-DD');
    }

    createUser(data);
  };

  const breadcrumbs = [
    {
      title: 'Employees',
      to: '/admin/employees'
    }
  ];

  return (
    <>
      <AdminSubHeader title="Create Employee" breadcrumbs={breadcrumbs} />
      <div className="m-content">
        {((defaultCompanyId && defaultCompany) || !defaultCompanyId) && (
          <EmployeeForm
            authUser={authUser}
            onSubmit={handleSubmit}
            defaultCompany={defaultCompany}
            formSubmitting={isCreating}
            ajaxErrors={ajaxErrors}
          />
        )}
      </div>
    </>
  );
};

EmployeesCreate.propTypes = {
  createUser: PropTypes.func,
  resetErrors: PropTypes.func,
  isCreating: PropTypes.bool,
  ajaxErrors: PropTypes.object,
  authUser: PropTypes.object
};

const mapStateToProps = (state, props) => ({
  authUser: selectUser(state),
  isCreating: userCreating(state),
  ajaxErrors: userErrors(state)
});

const mapDispatchToProps = dispatch => ({
  createUser: (values, permissions) =>
    dispatch(USERS_ACTIONS.createRequest(values, permissions)),
  resetErrors: () => dispatch(USERS_ACTIONS.resetErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesCreate);
